export type TransactionStatus = 'COMPLETED' | 'PENDING' | 'PARTIAL' | 'CANCELLED';
export type TransactionType = 'SALE' | 'RETURN';
export type SaleChannel = 'shopify' | 'in-store' | null;

export const TRANSACTION_STATUS_OPTIONS: TransactionStatus[] = [
  'COMPLETED',
  'PENDING',
  'PARTIAL',
  'CANCELLED',
];

export const TRANSACTION_STATUS_LABELS: Record<TransactionStatus, string> = {
  COMPLETED: 'Completado',
  PENDING: 'Pendiente',
  PARTIAL: 'Parcial',
  CANCELLED: 'Cancelado',
};

export const TRANSACTION_TYPE_OPTIONS: TransactionType[] = ['SALE', 'RETURN'];

export const TRANSACTION_TYPE_LABELS: Record<TransactionType, string> = {
  SALE: 'Venta',
  RETURN: 'Devolución',
};

export interface ProductSaleRow {
  transactionId: number;
  transactionCreatedAt: string;
  productName: string;
  imageUrl: string | null;
  artId: string | null;
  variantId: number;
  variantName: string;
  type: TransactionType;
  status: TransactionStatus;
  channel: SaleChannel;
  shopifySaleId: string | null;
}

export interface ProductSalesListPayload {
  items: ProductSaleRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ProductSalesListQuery {
  page?: number;
  pageSize?: number;
  productName?: string;
  status?: TransactionStatus | '';
  type?: TransactionType | '';
  shopifySaleId?: string;
  variantSearch?: string;
}
